<template>
  <div class="nut-item">
    <app-sel
      :styling="'inline'"
      :border="'no-border'"
      key-name="label"
      v-model="selected"
      :items="item.types"
      v-if="item.types"
    >
      <template v-slot="{ items }">
        <app-sel-opt
          :value="item"
          v-for="(item, i) in items"
        >
          {{ item.label }}
        </app-sel-opt>
      </template>
    </app-sel>
    <span class="name-nut" v-else>
      {{item.key}}
    </span>
    <span :key="keyFlag">
      <app-text-input
        type="number"
        hint="%"
        @input="onInput"
        :value="convert()"
        :placeholder="item.key"
        class="app-styling"
        v-if="item.types"
        min="0"
        :max="max"
        :digits-after-dot="2"
        :disabled="disabled"
      />
      <app-text-input
        type="number"
        hint="%"
        v-model="data[name]"
        :placeholder="item.key"
        class="app-styling"
        v-else
        min="0"
        :max="max"
        :digits-after-dot="2"
        :disabled="disabled"
      />
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { NutrientConverter } from '@/mixins/nutrient-converter.mixin';

export default {
  mixins: [ NutrientConverter  ],
  props: {
    item: Object,
    data: Object,
    name: String
  },
  data () {
    return {
      selected: null,
      old: 0,
      inputFlag: false,
      keyFlag: 0,
      disabled: false,
      max: 100
    }
  },
  methods: {
    onInput(value) {
      this.old = this.data[this.name];
      this.data[this.name] = this.unconvertNutrientType(this.item.key, this.selected, value);
      this.inputFlag = true;
      setTimeout(() => {
        this.inputFlag = false;
      }, 200);

      if (['NNO3', 'NNH2', 'NNH4'].includes(this.item.key)) {
        this.$store.commit('fertilizers/popup/setN');
      }
    },
    convert() {
      let val = this.convertNutrientType(this.item.key, this.selected, this.data[this.name]);

      if(this.selected != this.item.types[0].label) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      
      return typeof val === 'number' ? val.toFixedGentle(1) : null;
    },
  },
  created () {
    if (this.item.types) {
      this.selected = this.item.key;
    }
  },
  computed: {
    ...mapGetters({
      flagPerc: 'fertilizers/popup/flagPerc'
    })
  },
  watch: {
    flagPerc: function (val) {
      if (!val && this.inputFlag) {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Total nutrients should not exceed 100%`),
          type : 'failed',
        });

        this.data[this.name] = this.old;
        this.keyFlag++;

        if (['NNO3', 'NNH2', 'NNH4'].includes(this.item.key)) {
          this.$store.commit('fertilizers/popup/setN');
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .app-styling input {
    &::placeholder {
      font-size: 14px !important;
    }
  }
}

.nut-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 110px;
  margin: 15px;
  .app-sel {
    min-width: 100px;
  }
  span > div {
    padding: 1px;
    min-width: 110px;
  }
  .name-nut {
    width: 80px;
    min-width: 80px;
    height: 42px;
    // padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  // &:last-child {
  //   width: auto;
  // }

  @media (max-width: 768px) {
    width: calc(50% - 8px);
    margin: 0 0 32px 0;
  }
}
</style>
